import { i18n } from 'i18n';
import IdField from 'modules/shared/fields/idField';
import DateTimeField from 'modules/shared/fields/dateTimeField';
import DateTimeRangeField from 'modules/shared/fields/dateTimeRangeField';
import StringField from 'modules/shared/fields/stringField';
import BooleanField from 'modules/shared/fields/booleanField';
import RelationToOneField from 'modules/shared/fields/relationToOneField';
import JsonField from 'modules/shared/fields/jsonField';
import RelationToManyField from 'modules/shared/fields/relationToManyField';

function label(name) {
  return i18n(`entities.bot.fields.${name}`);
}
const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    required: true,
    min: 2,
    max: 255,
  }),
  phoneNumberId: new StringField(
    'phoneNumberId',
    label('phoneNumberId'),
    {
      required: true,
      min: 2,
      max: 255,
    }
  ),
  phoneNumber: new StringField(
    'phoneNumber',
    label('phoneNumber'),
    {
      required: false,
      min: 2,
      max: 255,
    }
  ),
  isPaid: new BooleanField('isPaid', label('isPaid')),
  catalog: new RelationToManyField(
      'catalog',
      label('catalog'),
      {
        required: false,
        min: 0,
        max: 10,
      },
  ),
  paymentMethods: new RelationToManyField(
    'paymentMethods',
    label('paymentMethods'),
    {
      required: false,
      min: 0,
      max: 10,
    }
  ),
  links: new RelationToManyField(
    'links',
    label('links'),
    {
      required: false,
      min: 0,
      max: 10,
    },
  ),
  accessToken: new StringField(
    'accessToken',
    label('accessToken'),
    {
      required: true,
      min: 2,
      max: 255,
    }
  ),
  cluster: new RelationToOneField('cluster', label('cluster'), {}),
  flow: new RelationToOneField('flow', label('flow'), { required: true }),
  enable: new BooleanField('enable', label('enable')),
  startDate: new DateTimeField(
    'startDate',
    label('startDate'),
  ),
  endDate: new DateTimeField(
    'endDate',
    label('endDate'),
  ),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  user: new RelationToOneField('user', label('user'), {
    required: true,
  })
};

export default {
  fields,
};
